import { Box, Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import { HSeparator } from "components/separator/Separator";
import { useAuth } from "contexts/AuthContext";
import { useSidebar } from "contexts/SidebarContext";
import { usePartner } from "hooks/usePartner";

const publicAsset = (path: string) =>
  `${process.env.PUBLIC_URL ?? ""}${path}`;

export default function SidebarBrand() {
  const { user } = useAuth();
  const { partner } = usePartner();
  const { sidebarCollapsed } = useSidebar();
  const logoSrc = useColorModeValue(
    publicAsset("/car-light.svg"),
    publicAsset("/car-dark.svg")
  );
  const subtitleColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );

  const partnerDisplayName =
    partner?.name ?? user?.email?.split("@")[0] ?? "Parceiro";

  if (sidebarCollapsed) {
    return (
      <Flex alignItems="center" flexDirection="column" px="4px">
        <Box my="16px" w="100%" display="flex" justifyContent="center">
          <Image
            src={logoSrc}
            alt="OnlyWine"
            height="44px"
            objectFit="contain"
            maxW="56px"
          />
        </Box>
        <HSeparator mb="12px" mt="12px" />
      </Flex>
    );
  }

  return (
    <Flex alignItems="center" flexDirection="column">
      <Flex direction="column" align="center" my="32px" px="12px">
        <Image
          src={logoSrc}
          alt="OnlyWine"
          height="130px"
          objectFit="contain"
        />
        <Text
          fontSize="22px"
          fontWeight="normal"
          color="brand.500"
          fontFamily="Volkhov-Bold"
        >
          OnlyWine
        </Text>
        <Text
          fontSize="13px"
          fontWeight="500"
          color={subtitleColor}
          textAlign="center"
          noOfLines={2}
        >
          {partnerDisplayName}
        </Text>
      </Flex>
      <HSeparator mb="20px" />
    </Flex>
  );
}
